(function () {
  'use strict';

  function closeTooltipWrappers(exceptWrapper) {
    document.querySelectorAll('.tooltip-wrapper.is-open').forEach(function (wrapper) {
      if (wrapper !== exceptWrapper) {
        wrapper.classList.remove('is-open');
        wrapper.classList.remove('is-viewport-positioned');
        wrapper.style.removeProperty('--tooltip-top');
        wrapper.style.removeProperty('--tooltip-left');
        wrapper.style.removeProperty('--tooltip-width');
        wrapper.style.removeProperty('--tooltip-bridge-left');
        wrapper.style.removeProperty('--tooltip-bridge-top');
        wrapper.style.removeProperty('--tooltip-bridge-width');
        wrapper.style.removeProperty('--tooltip-bridge-height');
      }
    });
  }

  function clearTooltipPosition(wrapper) {
    if (!wrapper) return;

    wrapper.classList.remove('is-viewport-positioned');
    wrapper.style.removeProperty('--tooltip-top');
    wrapper.style.removeProperty('--tooltip-left');
    wrapper.style.removeProperty('--tooltip-width');
    wrapper.style.removeProperty('--tooltip-bridge-left');
    wrapper.style.removeProperty('--tooltip-bridge-top');
    wrapper.style.removeProperty('--tooltip-bridge-width');
    wrapper.style.removeProperty('--tooltip-bridge-height');
  }

  function positionTooltip(wrapper) {
    if (!wrapper || !wrapper.classList.contains('is-open')) return;

    var popup = wrapper.querySelector('.block-addon-option__tooltip-popup, .tooltip-popup');
    var trigger = wrapper.querySelector('.info-icon, .block-addon-option__info-icon');

    if (!popup || !trigger) return;

    wrapper.classList.add('is-viewport-positioned');

    var viewportPadding = 12;
    var gap = 8;
    var triggerRect = trigger.getBoundingClientRect();
    var label = wrapper.closest('.block-addon-option__label, .product-option__add-on, .block-addon-option__item, .block-addon-option');
    var labelRect = label ? label.getBoundingClientRect() : triggerRect;
    var popupRect = popup.getBoundingClientRect();
    var popupWidth = Math.min(popupRect.width || 240, window.innerWidth - viewportPadding * 2);
    var popupHeight = popupRect.height || 260;
    var leftSpace = labelRect.left - viewportPadding - gap;
    var left = labelRect.left - popupWidth - gap;
    var top = triggerRect.top + (triggerRect.height / 2) - (popupHeight / 2);

    if (left < viewportPadding && leftSpace >= 160) {
      popupWidth = Math.min(popupWidth, leftSpace);
      left = viewportPadding;
    } else if (left < viewportPadding) {
      left = labelRect.right + gap;
    }

    left = Math.max(viewportPadding, Math.min(left, window.innerWidth - popupWidth - viewportPadding));
    if (top + popupHeight > window.innerHeight - viewportPadding) {
      top = Math.max(viewportPadding, window.innerHeight - popupHeight - viewportPadding);
    }

    wrapper.style.setProperty('--tooltip-left', left + 'px');
    wrapper.style.setProperty('--tooltip-top', top + 'px');
    wrapper.style.setProperty('--tooltip-width', popupWidth + 'px');

    var bridgeLeft = Math.min(labelRect.left, left);
    var bridgeTop = Math.min(labelRect.top, top);
    var bridgeRight = Math.max(labelRect.right, left + popupWidth);
    var bridgeBottom = Math.max(labelRect.bottom, top + popupHeight);
    wrapper.style.setProperty('--tooltip-bridge-left', bridgeLeft + 'px');
    wrapper.style.setProperty('--tooltip-bridge-top', bridgeTop + 'px');
    wrapper.style.setProperty('--tooltip-bridge-width', Math.max(0, bridgeRight - bridgeLeft) + 'px');
    wrapper.style.setProperty('--tooltip-bridge-height', Math.max(0, bridgeBottom - bridgeTop) + 'px');
  }

  function positionOpenTooltips() {
    document.querySelectorAll('.tooltip-wrapper.is-open').forEach(positionTooltip);
  }

  function pointInRect(point, rect) {
    if (!point || !rect) return false;

    return (
      point.x >= rect.left &&
      point.x <= rect.right &&
      point.y >= rect.top &&
      point.y <= rect.bottom
    );
  }

  function getBridgeRect(firstRect, secondRect, padding) {
    if (!firstRect || !secondRect) return null;

    var safePadding = padding || 0;

    return {
      left: Math.min(firstRect.left, secondRect.left) - safePadding,
      right: Math.max(firstRect.right, secondRect.right) + safePadding,
      top: Math.min(firstRect.top, secondRect.top) - safePadding,
      bottom: Math.max(firstRect.bottom, secondRect.bottom) + safePadding
    };
  }

  function initTooltipClickOpen(context) {
    var root = context && typeof context.querySelectorAll === 'function' ? context : document;

    root.querySelectorAll('.tooltip-wrapper').forEach(function (wrapper) {
      if (wrapper.getAttribute('data-tooltip-click-ready') === 'true') return;
      wrapper.setAttribute('data-tooltip-click-ready', 'true');

      var trigger = wrapper.querySelector('.info-icon, .block-addon-option__info-icon');
      if (!trigger) return;

      var popup = wrapper.querySelector('.block-addon-option__tooltip-popup, .tooltip-popup');
      var closeTimer = null;
      var lastPointer = { x: 0, y: 0 };

      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-expanded', 'false');

      function cancelTooltipClose() {
        if (!closeTimer) return;
        clearTimeout(closeTimer);
        closeTimer = null;
      }

      function openTooltip() {
        cancelTooltipClose();
        closeTooltipWrappers(wrapper);
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');

        requestAnimationFrame(function () {
          positionTooltip(wrapper);
        });
      }

      function closeTooltip() {
        cancelTooltipClose();
        wrapper.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        clearTooltipPosition(wrapper);
      }

      function shouldKeepTooltipOpen() {
        var triggerRect = trigger.getBoundingClientRect();
        var popupRect = popup ? popup.getBoundingClientRect() : null;
        var bridgeRect = getBridgeRect(triggerRect, popupRect, 10);

        return (
          pointInRect(lastPointer, triggerRect) ||
          pointInRect(lastPointer, popupRect) ||
          pointInRect(lastPointer, bridgeRect)
        );
      }

      function scheduleTooltipClose(event) {
        if (event && typeof event.clientX === 'number') {
          lastPointer = { x: event.clientX, y: event.clientY };
        }

        cancelTooltipClose();
        closeTimer = setTimeout(function () {
          if (shouldKeepTooltipOpen()) return;
          closeTooltip();
        }, 220);
      }

      function toggleTooltip(event) {
        event.preventDefault();
        event.stopPropagation();

        if (wrapper.classList.contains('is-open')) {
          closeTooltip();
        } else {
          openTooltip();
        }
      }

      trigger.addEventListener('click', toggleTooltip);
      trigger.addEventListener('mouseenter', openTooltip);
      wrapper.addEventListener('mouseleave', scheduleTooltipClose);
      document.addEventListener('mousemove', function (event) {
        if (!wrapper.classList.contains('is-open')) return;

        lastPointer = { x: event.clientX, y: event.clientY };
        if (shouldKeepTooltipOpen()) {
          cancelTooltipClose();
        }
      });
      if (popup) {
        popup.addEventListener('mouseenter', cancelTooltipClose);
        popup.addEventListener('mouseleave', scheduleTooltipClose);
      }
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          toggleTooltip(event);
        }
      });
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.tooltip-wrapper')) return;
    closeTooltipWrappers(null);
  });

  window.addEventListener('scroll', positionOpenTooltips, { passive: true });
  window.addEventListener('resize', positionOpenTooltips);

  document.addEventListener('DOMContentLoaded', function () {
    initTooltipClickOpen(document);
  });

  document.addEventListener('mouseover', function (event) {
    var wrapper = event.target.closest('.tooltip-wrapper');
    if (!wrapper || wrapper.getAttribute('data-tooltip-click-ready') === 'true') return;
    initTooltipClickOpen(wrapper.parentNode || document);
  });

  document.addEventListener('focusin', function (event) {
    var wrapper = event.target.closest('.tooltip-wrapper');
    if (!wrapper || wrapper.getAttribute('data-tooltip-click-ready') === 'true') return;
    initTooltipClickOpen(wrapper.parentNode || document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initTooltipClickOpen(event.target || document);
  });

  if (window.MutationObserver) {
    var tooltipObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('.tooltip-wrapper')) {
            initTooltipClickOpen(node.parentNode || document);
          } else if (node.querySelector && node.querySelector('.tooltip-wrapper')) {
            initTooltipClickOpen(node);
          }
        });
      });
    });

    if (document.body) {
      tooltipObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        tooltipObserver.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  window.CustomTooltipPosition = window.CustomTooltipPosition || {};
  window.CustomTooltipPosition.init = initTooltipClickOpen;
  window.CustomTooltipPosition.positionOpen = positionOpenTooltips;
  window.CustomTooltipPosition.close = closeTooltipWrappers;
})();
